import React, { useState, useEffect } from "react";
import Api from "Api/Api";
import DataGrid, { Column } from "devextreme-react/data-grid";
import moment from "moment";
import Paginator from "components/common/Paginator";
import { connect } from "react-redux";
import { useUrlFilter } from "Hooks/utils";

function SentMails(props) {
  const { dispatch } = props;

  const [mails, setMails] = useState([]);
  const [count, setCount] = useState(0);
  const [filters] = useUrlFilter();

  useEffect(() => {
    if (filters) {
      loadData(filters?.page);
    }
  }, [filters]); // eslint-disable-line react-hooks/exhaustive-deps

  const loadData = (page = 1) => {
    dispatch({ type: "toggleLoad" });
    Api.mailLog(page).then((response) => {
      dispatch({ type: "toggleLoad" });
      if (response.status === 200) {
        setMails(response.data.results);
        setCount(response.data.count);
      }
    });
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header card-header-success">
            <div className="ct-chart" id="completedTasksChart">
              <div className="row">
                <div className="col-lg-9">
                  <div style={{ textTransform: "capitalize" }}>
                    <h4>Mails</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-body">
            <DataGrid dataSource={mails} searchPanel={{ visible: true }}>
              <Column dataField="from_email" />
              <Column dataField="person_name" />
              <Column dataField="fund_name" />
              <Column dataField="startup_name" />
              <Column dataField="cc" />
              <Column dataField="subject" />
              <Column
                dataField="created"
                cellRender={(e) => {
                  return moment(e.row.data.created).format("LLL");
                }}
              />
            </DataGrid>
            <Paginator totalItemsCount={count} pageRangeDisplayed={5} />
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps)(SentMails);
